import axios from 'axios';

export const read = () => axios.get('https://smartmap.at/api/layers/8/data', {
  headers: {
    'requested-content-type': 'application/geojson; charset=utf-8',
  },
});
